/**
 * InArticleAd — one Google AdSense in-article (native, fluid) unit.
 *
 * Renders nothing unless Admin > Settings has ads on and an in-article slot
 * ID set (useAdSettings). Placement rules live in docs/GOOGLE_ADS_SETUP.md:
 * only guides, the guide list and shared trips; max 2 per guide, 1
 * elsewhere; never next to buttons, players, vote/share controls or the map.
 *
 * Wrapper, label, push() and the unfilled collapse are shared with
 * MultiplexAd in AdUnit.jsx.
 *
 * `gap` = vertical space around a filled unit (CSS length, default 2.5rem).
 */
import { useLocation } from 'react-router-dom';
import useAdSettings from '@/hooks/useAdSettings';
import AdUnit from './AdUnit';

const IN_ARTICLE_INS = {
  style: { display: 'block', textAlign: 'center' },
  'data-ad-layout': 'in-article',
  'data-ad-format': 'fluid',
};

const InArticleAd = ({ position, gap }) => {
  const { enabled, client, slot } = useAdSettings();
  const { pathname } = useLocation();
  if (!enabled) return null;
  // Keyed by route + position so SPA navigation mounts a fresh <ins>.
  return (
    <AdUnit
      key={`${pathname}#${position}`}
      client={client}
      slot={slot}
      position={position}
      gap={gap}
      testId="in-article-ad"
      insProps={IN_ARTICLE_INS}
    />
  );
};

export default InArticleAd;
